:host {

    display: flex;
    ul {
      margin: 0;
      padding-left: 0;
      width: 100%;
    }
    .nested-tree {
      width: 100%;
    }
  }
  :host(.main-tree) {
    overflow: hidden;
  }
  .main-tree-container {
    position: relative;
    width: 100%;
  }